// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-B7418C28-918B-4E95-BA39-E15DAFF589C2 .single-file-item .template.single-file {\n  padding: 0;\n}\n", "",{"version":3,"sources":["webpack://src/uicomponents/components/filesList/filesList.less"],"names":[],"mappings":"AACI;EACI,UAAA;AAAR","sourcesContent":["#V-B7418C28-918B-4E95-BA39-E15DAFF589C2{\n    & .single-file-item .template.single-file{\n        padding: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
